module.exports = __webpack_public_path__ + "img/Logo-Emotiva-2020.252f2e59.svg";